import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom'
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { Row, Col, } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getDetails, getInterests } from '../../actions/AccountActions';
import { addVideoHistory, addChannelHistory } from '../../actions/HistoryActions';
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from '../../actions/FavoriteActions';
import { hideSplash } from '../../actions/SplashScreenActions';
import { Videos360 } from '../../constants/videos';
import { config } from '../../constants/domainConfig';
import { getUid } from '../../utils/helper';
import { sendData } from '../../analytics/sendData'
class LoginWithUsername extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isValid: false,
            reason: '',
            error: {},
            forgotPwdClicked: false,
            pwdResetSuccessfully: false,
            msisdnForPwdReset: config.countryCode,
            pwdResetCallFailed: false,
            subNotFound: false,
            msisdnForgotPwdInvalid: false
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.callAuthenticate = this.callAuthenticate.bind(this);
        this.callApis = this.callApis.bind(this);
        this.onClickForgotPwd = this.onClickForgotPwd.bind(this);
        this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
        this.onSubmitForgotPwd = this.onSubmitForgotPwd.bind(this);
        this.isMsisdnValid = this.isMsisdnValid.bind(this);
        this.onKeyUpForgotPWd = this.onKeyUpForgotPWd.bind(this);
    }
    filterVideos(allVids) {
        const restrictedVids = [27, 65];
        const restrictedVidsMe = [27, 50, 65, 91, 92];

        const vids = allVids.map(cat => {
            if (config.domain == 'me')
                return {
                    ...cat,
                    "videos": cat.videos.filter(vid => restrictedVidsMe.indexOf(vid.id) == -1)
                }
            // else if(config.domain === "demo"){
            //     return allVids.filter(category => {
            //         return ["Adventure", "Documentaries", "Escape Reality", "360 Library", "Amazement", "Mix VR", "3D Fun", "Entertainment", "Amazing 360", "360 World", "Tiktok Tips & Tricks"].indexOf(category.categoryName["en"]) < 0
            //     })
            // }
            else return {
                ...cat,
                "videos": cat.videos.filter(vid => restrictedVids.indexOf(vid.id) == -1)
            }
        })
        return vids;
    }

    isValid() {
        if (this.state.username == '') {
            this.setState({
                isValid: false,
                error: {
                    username: true
                }
            });
            return false;
        }
        if (this.state.password == '') {
            this.setState({
                isValid: false,
                error: {
                    password: true
                }
            });
            return false;
        }
        return true;
    }

    isMsisdnValid(){
        if (this.state.msisdnForPwdReset == '') {
            this.setState({
                isValid: false,
                msisdnForgotPwdInvalid: true
            });
            return false;
        }
        return true;

    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    onChangeMsisdn(e) {
        const { value, maxLength, name } = e.target;
        const truncatedValue = value.slice(0, maxLength);
        this.setState({ [name]: truncatedValue });
    }
    onKeyUp(e) {
        this.setState({
            msisdnForPwdReset: config.countryCode,
            pwdResetSuccessfully: false,
            pwdResetCallFailed: false,
            subNotFound: false,
            msisdnForgotPwdInvalid: false,
            forgotPwdClicked: false
            

        })
        if (e.keyCode == 13) {
            if (this.isValid()) {
                this.setState({ isValid: true });
                this.callAuthenticate({
                    username: this.state.username,
                    password: this.state.password
                });
            }
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.isValid()) {
            this.setState({ isValid: true});
            this.callAuthenticate({
                username: this.state.username,
                password: this.state.password

            });
        }
    }
    onClickForgotPwd(e){
        this.setState({
            forgotPwdClicked: true
        })
    }

    onKeyUpForgotPWd(e) {
        this.setState({
            username: '',
            password: '',
            error: {}
        })
        if (e.keyCode == 13) {
            this.onSubmitForgotPwd(e);
        }
    }

    callAuthenticate(data) {
        this.props.show();
        if(config.domain == 'pt') data.username = (config.countryCode).toString().concat(data.username.slice(-9));
        let dataToSend = {
            username: data.username,
            password: data.password,
            subDomain: config.domain
        }
        sessionStorage.setItem("username", dataToSend.username);
        sessionStorage.setItem("password", dataToSend.password);
        console.log('data to send', dataToSend);
        axios.post(vars.BASE_API_URL + `/checkAccessWithUsername`, dataToSend)
            .then((response) => {
                let data = {
                    success: response.data.success,
                    uid: response.data.data.payload.token,
                    token: response.data.data.token,
                    subscriptionInfo: response.data.data.payload 
                };
                sessionStorage.setItem("authorized", JSON.stringify(data))
                sendData('', '', '', 'Accessed', { method: 'username', rid: data.subscriptionInfo.rockmanId, status: 'success', url: window.location.href});
                this.props.checkAccess(data);
                if (response.data.success) {
                    axios.defaults.headers.common['authorization'] = response.data.data.token;
                    this.callApis()
                } else {
                    this.setState({
                        error: {
                            api: true
                        },
                        reason: response.data.data.payload.reason
                    })
                    this.props.hide();
                }
            })
            .catch((error) => {
                this.props.hide();
                console.log('----------------- in login with username',error);
                this.props.history.push("/loginWithUsername");
            });
    }
    transformRequest(headers) { 
        delete headers.common.authorization;
        return;
    }
    onSubmitForgotPwd(e) {
        if (this.isMsisdnValid()) {
            this.props.show();
            this.transformRequest(axios.defaults.headers);
            axios.get(`https://de-mcb-api.sam-media.com/api/v2/retrieve-password/pt/go4mobility?msisdn=${this.state.msisdnForPwdReset}&domain=${(window.location.hostname == 'localhost') ? 'pt.gamezones.biz' : window.location.hostname}`)
                .then(response => {
                    this.props.hide();
                    if (response.data.state == 'success') {
                        this.setState({
                            pwdResetSuccessfully: true
                        })
                    }
                    else {
                        this.setState({
                            subNotFound: true
                        })

                    }
                })
                .catch(err => {
                    this.props.hide();
                    console.log('err-----------------------', err);
                    this.setState({
                        pwdResetCallFailed: true
                    })
                })
        }
    }
    callApis() {
        this.props.category.videos = this.filterVideos(Videos360);

        if (this.props.account.interests.length <= 0) {

            axios.all([axios.get(vars.BASE_API_URL + '/interests'), axios.get(vars.BASE_API_URL + '/favorites'), axios.get(vars.BASE_API_URL + '/history'), axios.get(vars.BASE_API_URL + '/likes')])
                .then(axios.spread((interests, favorites, history, likes) => {

                    // for interests
                    if (interests.data.data) {
                        this.props.getInterests(interests.data.data);
                    }

                    // for favorites
                    if (favorites.data.data) {
                        this.props.addFavoriteChannel(favorites.data.data.channels);
                        this.props.addFavoriteVideo(favorites.data.data.videos);
                    }

                    // for history
                    if (history.data.data) {
                        this.props.addChannelHistory(history.data.data.channels);
                        this.props.addVideoHistory(history.data.data.videos);
                    }

                    // for likes
                    if (likes.data.data) {
                        this.props.addLikesChannels(likes.data.data.channels);
                        this.props.addLikesVideos(likes.data.data.videos);
                    }
                }))
                .then(() => {
                    axios.get(vars.BASE_API_URL + '/getUserProfile')
                        .then(userProfile => {
                            if (userProfile.data.data) {
                                this.props.getDetails(userProfile.data.data);

                            }
                            this.props.hide();
                        })
                        .catch(err => {
                            console.log('error in fetching user profile ----------', err);
                            this.props.hide();
                        })
                        console.log('user profile call finsiehd');
                    
                })
                .catch(err => {
                    console_log(err);
                });
        } else {
            this.props.getDetails(this.props.account.user);
            this.props.getInterests(this.props.account.interests);
            this.props.favorite && this.props.addFavoriteChannel(this.props.favorite.channels);
            this.props.favorite && this.props.addFavoriteVideo(this.props.favorite.videos);
            this.props.favorite && this.props.addLikesChannels(this.props.favorite.channelsLiked);
            this.props.favorite && this.props.addLikesVideos(this.props.favorite.videosLiked);
            this.props.historyVideos && this.props.addChannelHistory(this.props.historyVideos.channels);
            this.props.historyVideos && this.props.addVideoHistory(this.props.historyVideos.videos);
        }
        this.props.history.push(`/category/vod?uid=${this.props.access.uid}`);
        this.props.hide();
    }

    render() {
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="pleaseLogin"
                                        defaultMessage="Please login to continue"
                                    />
                                </h1>
                                {
                                    config.domain == 'tr' &&
                                    <p>
                                        <FormattedMessage id="loginUsing"
                                            defaultMessage="Login using the username and password you got in the welcome message"
                                        />
                                    </p>
                                }

                                <div className="login-page-mobile_num">
                                    {this.state.error.username && <span className="error-message">
                                        <FormattedMessage id="usernameRequired"
                                            defaultMessage="Username is required."
                                        />
                                    </span>}
                                    <FormattedMessage id="username" defaultMessage="Username">
                                        {placeholder =>
                                            <input autoFocus type="text" name="username" value={this.state.username} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                    {this.state.error.password && <span className="error-message">
                                        <FormattedMessage id="passwordRequired"
                                            defaultMessage="Password is required."
                                        />
                                    </span>}
                                    <FormattedMessage id="password" defaultMessage="Password">
                                        {placeholder =>
                                            <input type="password" name="password" value={this.state.password} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                    <button type="submit" onClick={this.onSubmit} className="LoginRoute-button">
                                        <FormattedMessage id="login"
                                            defaultMessage="Login"
                                        />
                                        <i className="icon-back"></i>
                                    </button>
                                    {this.state.error.api && <span className="error-message">
                                        {this.state.reason}
                                    </span>
                                    } 
                                </div>
                            </Row>
                        </Col>
                        {config.domain == 'pt' && 
                            <Row className="login-page-content">
                                <div className="login-page-mobile_num">
                                    <Link className="reg-link" to={`/forgot-password/?uid=${getUid()}`} >
                                        <FormattedMessage id="forgot-password-link"
                                            defaultMessage="Forgot Password"
                                        />
                                    </Link>
                                    {this.state.msisdnForgotPwdInvalid && <span className="error-message">
                                        <FormattedMessage id="phoneNumberRequired"
                                            defaultMessage="Phone number is required."
                                        />
                                    </span>}
                                    {this.state.forgotPwdClicked && <input autoFocus type="number" name="msisdnForPwdReset" maxLength="15" value={this.state.msisdnForPwdReset} onChange={this.onChangeMsisdn} onKeyUp={this.onKeyUpForgotPWd} className="LoginRoute-number" />
                                    }
                                    {this.state.forgotPwdClicked && <button type="submit" onClick={this.onSubmitForgotPwd} className="LoginRoute-button">
                                        <FormattedMessage id="submit"
                                            defaultMessage="Submit"
                                        />
                                        <i className="icon-back"></i>
                                    </button>}
                                    {this.state.pwdResetSuccessfully && <span className="success-message">
                                        <FormattedMessage id="pwdResetSuccessfully"
                                            defaultMessage="An SMS with your password has been sent to you. Please try to login again using that password."
                                        />
                                    </span>
                                    }
                                    {this.state.pwdResetCallFailed && <span className="error-message">
                                        <FormattedMessage id="pwdResetFailed"
                                            defaultMessage="Password could not be reset. Please try again."
                                        />
                                    </span>
                                    }
                                    {this.state.subNotFound && <span className="error-message">
                                        <FormattedMessage id="subNotFound"
                                            defaultMessage="Your subscription with this mobile number was not found. Please subscribe to the service to continue."
                                        />
                                    </span>
                                    }
                                </div>



                            </Row>
                        }
                    </Row>
                </div>
            );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer,
        category: state.CategoryReducer,
        account: state.AccountReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        hideSplash,
        show,
        hide,
        addFavoriteChannel,
        addFavoriteVideo,
        getInterests,
        getDetails,
        addVideoHistory,
        addChannelHistory,
        addLikesChannels,
        addLikesVideos
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithUsername);



// WEBPACK FOOTER //
// ./src/components/Login/LoginWithUsername.js